import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment/moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { Appointment } from '../../../../data/patient/domain/appointment/appointment';
import { Patient } from '../../../../data/patient/domain/patient';
import {
  MySideBarNavigationTabs,
  SideBarItem,
} from '../../../components/sidebar-cell/sidebar.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-my-sidebar',
  templateUrl: './my-sidebar.component.html',
  styleUrls: ['./my-sidebar.component.scss'],
})
export class MySidebarComponent implements OnInit {
  @Input() patient?: Patient | undefined;
  @Input() appointment?: Appointment | undefined;
  @Input() weight?: number | undefined;
  @Input() size?: number | undefined;
  @Input() isWeightLoading: boolean;
  @Output() signOut = new EventEmitter();
  public items: SideBarItem[] = [];
  public activeTab: MySideBarNavigationTabs;
  public bsModalRef?: BsModalRef;

  constructor(
    private router: Router,
    private location: Location,
    private modalService: BsModalService,
  ) {
    // nada
  }

  ngOnInit(): void {
    this.getCurrentTab();
  }

  goToHome() {
    this.router.navigate(['/', 'my', this.getMenuItems()[0].navigateTo]).then();
  }

  onChange(item: SideBarItem) {
    if (item.navigateTo) {
      const commands = ['/', 'my'];
      item.navigateTo.split('/').forEach((part) => commands.push(part));
      this.router.navigate(commands).then(() => this.getCurrentTab());
    }
  }

  getCurrentTab() {
    const location = this.location.path()?.split('/')[2]?.split('?')[0];
    switch (location) {
      case 'home':
        this.activeTab = MySideBarNavigationTabs.HOME;
        break;
      case 'messages':
        this.activeTab = MySideBarNavigationTabs.MESSAGE;
        break;
      case 'documents':
        this.activeTab = MySideBarNavigationTabs.DOCUMENT;
        break;
      case 'profile':
        this.activeTab = MySideBarNavigationTabs.ACCOUNT;
        break;
      default:
        this.activeTab = MySideBarNavigationTabs.HOME;
        break;
    }

    this.items = this.getMenuItems();
  }

  private getMenuItems() {
    const results = [
      <SideBarItem>{
        icon: 'iconly-Home',
        label: 'Votre journal',
        selected: this.activeTab == MySideBarNavigationTabs.HOME,
        tabValue: MySideBarNavigationTabs.HOME,
        navigateTo: 'home',
        condition: () => true,
        onlyDesktop: false,
      },
      <SideBarItem>{
        icon: 'iconly-Edit',
        label: 'Vos messages',
        selected: this.activeTab == MySideBarNavigationTabs.MESSAGE,
        tabValue: MySideBarNavigationTabs.MESSAGE,
        navigateTo: 'messages',
        condition: () => true,
        onlyDesktop: true,
      },
      <SideBarItem>{
        icon: 'iconly-Document',
        label: 'Vos documents',
        selected: this.activeTab == MySideBarNavigationTabs.DOCUMENT,
        tabValue: MySideBarNavigationTabs.DOCUMENT,
        navigateTo: 'documents',
        condition: () => true,
        onlyDesktop: true,
      },
      <SideBarItem>{
        icon: 'iconly-Profile',
        label: 'Votre compte',
        selected: this.activeTab == MySideBarNavigationTabs.ACCOUNT,
        tabValue: MySideBarNavigationTabs.ACCOUNT,
        navigateTo: 'profile',
        condition: () => true,
        onlyDesktop: true,
      },
    ];

    return results;
  }

  get formattedCreatedAtDate() {
    return moment(this.patient?.createdAt).format('DD.MM.yyyy');
  }

  imc(weight: number | undefined, size: number | undefined) {
    return Patient.imc(weight, size)?.toString();
  }
}
